import { axiosInstance } from "./appService";

export function commonPostApi(api, payload, headers) {
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(api, payload, headers)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function commonGetApi(api) {
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(api)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function commonPutApi(api, payload, headers) {
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(api, payload, headers)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function commonDeleteApi(api, headers) {
  return new Promise((resolve, reject) => {
    axiosInstance
      .delete(api, headers)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

